<template>
    <div class="kgk-wettbewerb">
        <h1>Wettbewerb</h1>
        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">
            <p>Fehler: {{ error }}</p>
        </div>
        <div v-else-if="competitions.length === 0">
            <p>Aktuell läuft kein Wettbewerb für dich.</p>
        </div>
        <div v-else>
            <div v-for="competition in competitions" :key="competition.identifier" class="kgk-wettbewerb-card">
                <img v-if="competition.logo_url" :src="competition.logo_url" :alt="competition.name" class="kgk-wettbewerb-logo">
                <h2>{{ competition.name }}</h2>
                <p>
                    <i class="fas" :class="competition.competition_type === 'team' ? 'fa-flag' : 'fa-building'"></i>
                    {{ competition.competition_type === 'team' ? 'Team-Wettbewerb' : 'Firmen-Wettbewerb' }}
                    &middot;
                    {{ formatDate(competition.start_date) }} &ndash; {{ formatDate(competition.stop_date) }}
                </p>

                <Progress
                    v-if="competition.target > 0"
                    :radius="80"
                    :strokeWidth="20"
                    :value="progressPercent(competition)"
                    :overflowValue="overflowPercent(competition)"
                    :strokeColor="'#82C800'">
                    <template v-slot:footer>
                        <h1>{{ convertNumberReadable(Math.round(competition.kilometerstand_aktuell * 10) / 10) }} / {{ convertNumberReadable(competition.target) }} km</h1>
                    </template>
                </Progress>
                <p v-else>
                    <b>{{ convertNumberReadable(Math.round(competition.kilometerstand_aktuell * 10) / 10) }} km</b> bisher gesammelt.
                </p>

                <p v-if="competition.donate > 0">
                    Spendenbetrag: {{ convertNumberReadable(competition.donate) }} &euro;
                </p>

                <div v-if="competition.rendered_text" class="kgk-wettbewerb-text" v-html="competition.rendered_text"></div>

                <div v-if="competition.competition_type === 'team'" class="kgk-wettbewerb-leaderboard">
                    <LeaderboardTeams :all="true" :show-switch-button="false" />
                </div>

                <div v-else-if="competition.competition_type === 'company'">
                    <div class="kgk-wettbewerb-leaderboard">
                        <LeaderboardCompanyCompetition />
                    </div>

                    <div v-if="stepsChallengeEnabled">
                        <div v-if="companyVerified" class="kgk-wettbewerb-leaderboard">
                            <LeaderboardCompanysteps />
                            <LeaderboardCompanyGroupSteps />
                        </div>
                        <p v-else style="font-size:12px">
                            Deine Firma nimmt an der Schrittzähler-Challenge teil -- du musst dich aber erst von deiner Firma verifizieren lassen, um die interne Rangliste zu sehen.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import user from '../api/user';
    import Progress from '../components/easy-circular-progress/index';
    import LeaderboardTeams from '../components/leaderboards/LeaderboardTeams.vue';
    import LeaderboardCompanysteps from '../components/leaderboards/LeaderboardCompanysteps.vue';
    import LeaderboardCompanyGroupSteps from '../components/leaderboards/LeaderboardCompanyGroupSteps.vue';
    import LeaderboardCompanyCompetition from '../components/leaderboards/LeaderboardCompanyCompetition.vue';

    export default {
        name: 'Wettbewerb',
        components: { Progress, LeaderboardTeams, LeaderboardCompanysteps, LeaderboardCompanyGroupSteps, LeaderboardCompanyCompetition },
        data() {
            return {
                loading: false,
                error: null,
                competitions: [],
            }
        },
        computed: {
            // Wettbewerb.vue is rendered via <router-view> directly inside
            // App.vue -- $parent is the App.vue instance holding the loaded
            // user object, same pattern CompanyManager.vue already uses.
            stepsChallengeEnabled() {
                return this.$parent.user.company_competition_mode == 1;
            },
            companyVerified() {
                return this.$parent.user.company_connection_verified == 1;
            },
        },
        methods: {
            progressPercent(competition) {
                if (!competition.target) {
                    return 0;
                }
                return Math.min(100, Math.round(competition.kilometerstand_aktuell / competition.target * 100 * 10) / 10);
            },
            overflowPercent(competition) {
                if (!competition.target) {
                    return 0;
                }
                const raw = Math.round(competition.kilometerstand_aktuell / competition.target * 100 * 10) / 10;
                return raw > 100 ? raw - 100 : 0;
            },
            formatDate(value) {
                if (!value) {
                    return '';
                }
                const date = new Date(value);
                return date.toLocaleDateString('de-DE');
            },
        },
        mounted() {
            this.loading = true;

            user.getActiveCompetitions(
                this,
                data => {
                    this.competitions = data.competitions || [];
                },
                () => this.error = 'Es ist ein Fehler aufgetreten',
                () => this.loading = false,
            );
        },
    }
</script>

<style scoped lang="scss">
    .kgk-wettbewerb-card {
        max-width: 700px;
        margin: 0 auto 30px auto;
        text-align: center;
    }

    .kgk-wettbewerb-logo {
        max-width: 200px;
        max-height: 100px;
        object-fit: contain;
        margin: 0 auto 20px auto;
        display: block;
    }

    .kgk-wettbewerb-text {
        margin-top: 20px;
        text-align: left;
    }

    .kgk-wettbewerb-leaderboard {
        margin-top: 30px;
        text-align: left;
    }
</style>
